import { useEffect, useState } from 'react';

export const useScript = () => {
    const [isJavaScriptClientEnabled, setIsJavaScriptClientEnabled] = useState(false);

    useEffect(() => {
        setIsJavaScriptClientEnabled(true);
    }, []);

    return {
        isJavaScriptClientEnabled
    };
};
